import React from 'react';
import { Link } from 'react-router-dom';
import { Notification } from '@carbon/icons-react';
import { AppSwitcher } from '@carbon/icons-react';

import {
  Header,
  HeaderName,
  HeaderNavigation,
  HeaderMenu,
  HeaderMenuItem,
  HeaderGlobalBar,
  HeaderGlobalAction,
  HeaderPanel,
  SkipToContent,
  Switcher,
  SwitcherDivider,
  SwitcherItem,
} from '@carbon/react';

const EditorHeader = () => (
  <Header aria-label="Particle Editor">
    <SkipToContent />
    <HeaderName element={Link} to="/" prefix="Red Panda">
      Particle Editor
    </HeaderName>
	<HeaderGlobalBar>
	{/*
      <HeaderGlobalAction
		aria-label="App Switcher"
		isActive
		onClick={() => {}}
	  >
        <AppSwitcher/>
      </HeaderGlobalAction>
	  */}
    </HeaderGlobalBar>
	{/*
	<HeaderPanel expanded>
	  <Switcher>
		<SwitcherItem>
		Particle Editor
		</SwitcherItem>
		<SwitcherDivider/>
		<SwitcherItem>
		<Link href="https://redpandalab.freshdesk.com/support/home">Knowledge Base</Link>
		</SwitcherItem>
		<SwitcherItem> 
		<Link href="http://www.redpandalab.com/downloads/">Downloads</Link>
		</SwitcherItem>
		<SwitcherItem>
		<Link href="http://www.redpandalab.com/contact/">Contact Us</Link>
		</SwitcherItem>
	  </Switcher>
	</HeaderPanel>
	  */}
  </Header>
);

export default EditorHeader;
